import styled from "styled-components";

// รวมสไตล์ของทุกแท็บ/modal ในหน้านี้ (modal ใช้ Modals.BodyEmpty ที่ render อยู่ใต้ container นี้)
export const SeatBookingContainerStyled = styled.div`
  border-radius: 1rem;
  padding: 1.25rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  font-size: ${({ theme }) => theme.FONT.SIZE.S14};

  .empty_block {
    padding: 2rem;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .header_row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1rem;
    .title {
      font-size: ${({ theme }) => theme.FONT.SIZE.S20};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }
    .sub_title {
      color: ${({ theme }) => theme.COLORS.GRAY_2};
    }
    .header_btns {
      display: flex;
      column-gap: 10px;
    }
  }
  .w100 { width: 100px; }
  .w120 { width: 120px; }
  .w140 { width: 140px; }
  .w160 { width: 160px; }
  .w200 { width: 200px; }
  .w400 { width: 400px; max-width: 100%; }
  .account_qr_preview {
    display: block;
    width: 200px;
    max-width: 100%;
    margin-bottom: 10px;
    border: 1px solid #d9d9e0;
    border-radius: 8px;
  }

  .tab_row {
    display: flex;
    column-gap: 4px;
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
    margin-bottom: 1.25rem;
    .tab_item {
      padding: 8px 18px;
      cursor: pointer;
      border-radius: 8px 8px 0 0;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      &.active {
        background: ${({ theme }) => theme.COLORS.PURPLE_1};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
      }
    }
  }

  .section_title {
    margin: 1.25rem 0 0.75rem;
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }
  .preset_or {
    margin-top: 1rem;
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }
  .hint {
    margin-top: 4px;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
  }
  .input_row {
    margin-bottom: 14px;
    display: flex;
    width: 100%;
    .f_left_col {
      width: 22%;
      display: flex;
      align-items: center;
    }
    .f_right_col {
      width: 45%;
    }
  }
  .seat_map_preview {
    position: relative;
    width: 640px;
    max-width: 100%;
    margin-bottom: 14px;
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_4};
    border-radius: 8px;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      user-select: none;
    }
    .map_area {
      position: absolute;
      border: 2px solid transparent;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        border-color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
      &.active {
        border-color: ${({ theme }) => theme.COLORS.PURPLE_1};
        background: rgba(75, 30, 120, 0.2);
      }
    }
  }
  .inline_row {
    display: flex;
    align-items: center;
    column-gap: 10px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }
  .warn_box,
  .info_box {
    margin: 10px 0;
    padding: 10px 14px;
    border-radius: 8px;
    ul {
      margin: 4px 0 0;
      padding-left: 18px;
    }
  }
  .warn_box {
    background: #fff4e0;
    color: #8a5a00;
  }
  .info_box {
    background: ${({ theme }) => theme.COLORS.BLUE_5};
    color: ${({ theme }) => theme.COLORS.BLUE_3};
  }
  .error_text {
    color: ${({ theme }) => theme.COLORS.RED_1};
  }

  .stat_row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 12px;
    .stat_item {
      min-width: 130px;
      padding: 10px 14px;
      border-radius: 10px;
      background: #f2edfa;
      .stat_label {
        color: #595966;
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      }
      .stat_value {
        font-size: ${({ theme }) => theme.FONT.SIZE.S18};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
    }
  }
  .chip_row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    .chip {
      padding: 6px 14px;
      border-radius: 18px;
      cursor: pointer;
      background: ${({ theme }) => theme.COLORS.PURPLE_3};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      &.active {
        background: ${({ theme }) => theme.COLORS.PURPLE_1};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
      }
      &.static {
        cursor: default;
        background: #f2edfa;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
    }
  }
  .legend_row {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-bottom: 12px;
    .legend_item {
      display: flex;
      align-items: center;
      column-gap: 6px;
      .box {
        width: 16px;
        height: 16px;
        border-radius: 4px;
      }
    }
  }
  .action_bar {
    position: sticky;
    bottom: 0;
    margin-top: 14px;
    padding: 12px 14px;
    border-radius: 10px;
    background: ${({ theme }) => theme.COLORS.PURPLE_4};
    color: ${({ theme }) => theme.COLORS.WHITE_1};
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    .action_btns {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
  }

  .filter_row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    .filter_item {
      width: 180px;
    }
    .filter_keyword {
      width: 240px;
    }
  }
  .table_wrap {
    overflow-x: auto;
  }
  table.seat_table {
    width: 100%;
    min-width: 1280px;
    border-collapse: collapse;
    th,
    td {
      padding: 8px;
      border-bottom: 1px solid #d9d9e0;
      text-align: left;
      vertical-align: top;
    }
    td {
      color: #595966;
    }
    th {
      background: #f2edfa;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      white-space: nowrap;
    }
    .muted {
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    }
    .nowrap {
      white-space: nowrap;
    }
    .status_cell {
      min-width: 200px;
      max-width: 280px;
    }
    .amount_mismatch {
      color: #d93333;
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    }
    .warn_badge {
      display: inline-block;
      margin: 2px 4px 0 0;
      padding: 1px 8px;
      border-radius: 10px;
      background: #ffeb4c;
      color: #595966;
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    }
    .row_btns {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      min-width: 160px;
      /* สีปุ่มอนุมัติ/ปฏิเสธ/ยกเลิกตาม design (เฉพาะตารางนี้ ไม่แตะธีมปุ่มกลาง) */
      .theme_green .btn {
        background: #33994c;
        border-color: #33994c;
      }
      .theme_red .btn {
        background: #d93333;
        border-color: #d93333;
      }
    }
    a {
      color: #2973e6;
    }
  }
  .link_btn {
    border: none;
    background: none;
    padding: 0;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    cursor: pointer;
    text-decoration: underline;
  }

  .modal_card {
    position: relative;
    width: 640px;
    max-width: 92vw;
    max-height: 88vh;
    overflow-y: auto;
    padding: 20px 24px;
    border-radius: 14px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    .modal_title {
      margin-bottom: 14px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }
    .modal_row {
      margin-bottom: 12px;
      .m_label {
        margin-bottom: 4px;
      }
    }
    .modal_btns {
      margin-top: 18px;
      display: flex;
      justify-content: flex-end;
      column-gap: 10px;
    }
    .search_result {
      margin-top: 6px;
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
      border-radius: 8px;
      max-height: 180px;
      overflow-y: auto;
      .search_item {
        padding: 6px 10px;
        cursor: pointer;
        &:hover {
          background: ${({ theme }) => theme.COLORS.PURPLE_3};
        }
      }
    }
    .detail_grid {
      display: grid;
      grid-template-columns: 160px 1fr;
      row-gap: 6px;
      margin-bottom: 12px;
      .d_label {
        color: ${({ theme }) => theme.COLORS.GRAY_2};
      }
    }
    .qr_row {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      .qr_item {
        text-align: center;
      }
    }
    &.wide {
      width: 820px;
    }
  }
`;
